import React from 'react';
import { Box, Typography } from '@mui/material';
import { harmonatePageSx, harmonatePageTitleSx } from '../../theme/harmonateStyles';

const NoAccess = () => (
  <Box sx={{ ...harmonatePageSx, height: '100vh' }}>
    <Typography variant="h6" sx={harmonatePageTitleSx}>
      No screens available
    </Typography>
    <Typography sx={{ mt: 1, maxWidth: 520 }}>
      This role does not have any menus enabled. Ask an administrator to turn on a screen in Roles.
    </Typography>
  </Box>
);

export default NoAccess;
